import { render, staticRenderFns } from "./PoliceOfSecurity.vue?vue&type=template&id=010c6eff&"
import script from "./PoliceOfSecurity.vue?vue&type=script&lang=js&"
export * from "./PoliceOfSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports